/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.20",
    versionName: "0.7.0-nightly.2026.9.20",
    versionChannel: "nightly",
    buildDate: "2026-09-20T00:17:06.155Z",
    commitHash: "86a2ed7330859676d3c2e27908019db420be179b",
};
